module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/amazon_connect_wallpaper-90bd1cbe5f67a44a96d30c72ad6b65e0.jpg";